import { Button } from '@/components/ui/Button'
import {
  Dialog,
  DialogBody,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/Dialog'

export interface ConfirmRequest {
  title: string
  description: string
  confirmLabel: string
  destructive?: boolean
  onConfirm: () => void
}

interface ConfirmDialogProps {
  request: ConfirmRequest | null
  onClose: () => void
}

/** Driven by a nullable request object so a page can queue one from anywhere
 *  without threading open/close state through every row. */
export function ConfirmDialog({ request, onClose }: ConfirmDialogProps) {
  return (
    <Dialog open={!!request} onOpenChange={(open) => !open && onClose()} className="w-[420px]">
      <DialogHeader>
        <DialogTitle>{request?.title ?? ''}</DialogTitle>
        <DialogDescription>{request?.description ?? ''}</DialogDescription>
      </DialogHeader>
      <DialogBody className="py-1" />
      <DialogFooter>
        <Button variant="outline" onClick={onClose}>
          Cancel
        </Button>
        <Button
          variant={request?.destructive ? 'destructive' : 'default'}
          onClick={() => {
            request?.onConfirm()
            onClose()
          }}
        >
          {request?.confirmLabel ?? 'Confirm'}
        </Button>
      </DialogFooter>
    </Dialog>
  )
}
